import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'src/app/core/models/user.model';
import { AuthService } from 'src/app/core/services/auth.service';
import { SubscriptionService } from 'src/app/core/services/subscription.service';

@Component({
  selector: 'app-eligibility-filter',
  templateUrl: './eligibility-filter.component.html',
  styleUrls: ['./eligibility-filter.component.scss',],
})
export class EligibilityFilterComponent {

  showEligibleCars: boolean = false;

  constructor(
    private _authService: AuthService,
    private _router: Router,
    private _activateRoute: ActivatedRoute,
    private _subscriptionService: SubscriptionService
  ) {
    this._activateRoute.queryParams.subscribe({
      next: ({ maxPrice, eligibleCars, }) => {
        this.showEligibleCars = eligibleCars ? true : false;
        if (!maxPrice) {
          const queryParams = { ...this._activateRoute.snapshot.queryParams, };
          queryParams['eligibleCars'] = undefined;
          this._router.navigate([], {
            queryParams: queryParams,
          });
        }
      },
    });
  }

  onShowEligibleCars() {
    this.showEligibleCars = !this.showEligibleCars;

    if (!this.showEligibleCars) {
      const queryParams = { ...this._activateRoute.snapshot.queryParams, };
      const { maxPrice, } = queryParams;
      if (maxPrice) {
        queryParams['maxPrice'] = undefined;
        queryParams['eligibleCars'] = undefined;
        this._router.navigate([], {
          queryParams: queryParams,
        });
      }
      return;
    }

    if (!this._authService.getCurrentUser()) {
      this._router.navigateByUrl('auth');
      return;
    }
    
    this._subscriptionService.getSubscription().subscribe({
      next: (res) => {
        const currentSubscription = res?.subscriptions?.
          find((subscription: Subscription) => ['ACTIVE', 'PROSPECT',].includes(subscription.status));
        if (!currentSubscription) {
          this._router.navigateByUrl('dashboard');
          return;
        }
        const { eligibility: { calculatedEligibility, finalEligibility, }, } = currentSubscription;
        if (finalEligibility < calculatedEligibility) {
          this._router.navigate([], {
            queryParams: {
              maxPrice: finalEligibility,
              eligibleCars: true,
            },
            queryParamsHandling: 'merge',
          });
        } else {
          this._router.navigate([], {
            queryParams: {
              maxPrice: calculatedEligibility,
              eligibleCars: true,
            },
            queryParamsHandling: 'merge',
          });
        }
      },
    });
  }

}
